import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SrLink from 'client/components/SrLink/SrLink';

import './SrSunSpotEducationCard.less';

const DESCRIPTION_TO_COLOR = {
  green: 'At or above average lead volume.',
  orange: 'Slightly less than average lead volume.',
  red: 'Less than average lead volume.',
};

const SrSunSpotEducationCard = ({ listingStat }) => {
  const sunSpotColor =
    listingStat.sunSpot >= 1 ? 'green' : listingStat.sunSpot >= 0.8 ? 'orange' : 'red';

  return (
    <div styleName={classNames('cardBox', sunSpotColor)}>
      <span styleName="percentageText">{parseInt(listingStat.sunSpot * 100, 10)}%</span>
      <br />
      <span styleName="percentageLegend">of SunSpot</span>

      <div styleName="descriptionBox">
        <span styleName="descriptionText">{DESCRIPTION_TO_COLOR[sunSpotColor]}</span>
        <br />
        <span styleName="descriptionLegend">
          Sunroom compares how many people are interested in your listing each week vs similar
          listings.
        </span>

        <SrLink to="http://sunroomrentals.com/sunspot-education" target="_blank">
          <div styleName="questionMarkIcon">?</div>
        </SrLink>
      </div>
    </div>
  );
};

SrSunSpotEducationCard.propTypes = {
  listingStat: PropTypes.object.isRequired,
};

SrSunSpotEducationCard.displayName = 'SrSunSpotEducationCard';

export default SrSunSpotEducationCard;
